export enum Periodicity {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export type CellPeriod = {
  sequence: number;
  periodicity: Periodicity;
  name: string;
  value: string;
  published: string;
};

export type Entity = {
  value: string;
  label: string;
};

export enum SelectorPosition {
  left = 'left',
  right = 'right',
}

export type Cell = Entity & {
  countryCode: string;
  countryName: string;
  productCode: string;
  productName: string;
  periods: CellPeriod[];
  subscriptions: string;
};

export type Header = {
  label: string;
  sortBy: SortBy;
};

export enum SortBy {
  productGroup,
  country,
  lastMonth,
  lastWeek,
}

export enum SortDirection {
  ascending = 'asc',
  descending = 'desc',
}

export enum ContextSelectorWidth {
  auto = 'w-auto',
  max = 'w-max',
}
